import { build_locations_and_camp_names } from "../../tripPlanner/tripPlanner_util/tripPlanner_api_util";
import { openRouteInGoogleMapsApp } from "../../tripPlanner/tripPlanner_util/tripPlanner_g_map_util";
import { getTrip_cachedForm, meter_to_mi } from "../../util/general_util";
import { download_trip_gpx, download_trip_pdf, download_trip_xlsx } from "../api_utils";

export function init_controlPanel_listeners() {
	$(document).on("click","#printTrip",function(){
		let trip_dist:number = window.tripPlannerCurrentTrip.directions["routes"][0]["summary"]["distance"];
		let trip_duration:number = window.tripPlannerCurrentTrip.directions["routes"][0]["summary"]["duration"]
		let trip_dists:Array<number> = [];
		let trip_durations:Array<number> = [];

		for (let i:number = 0; i < window.tripPlannerCurrentTrip.directions["routes"][0]["segments"].length; i++) {
			trip_dists.push(window.tripPlannerCurrentTrip.directions["routes"][0]["segments"][i]["distance"])
			trip_durations.push(window.tripPlannerCurrentTrip.directions["routes"][0]["segments"][i]["duration"])
		};

		download_trip_pdf(getTrip_cachedForm(window.tripPlannerCurrentTrip),trip_dist,trip_duration,trip_dists,trip_durations).catch(e => {
			console.error(e);
		});
	});

	$(document).on("click", "#downloadGPX", function() {
		download_trip_gpx(getTrip_cachedForm(window.tripPlannerCurrentTrip)).catch(e => {
			console.error(e);
		});
	});

	$(document).on("click", "#openGoogleMaps", function() {
		try{
			openRouteInGoogleMapsApp(build_locations_and_camp_names(window.tripPlannerCurrentTrip))
		} catch (e) {
			console.error(e);
		}
	});

	$(document).on("click", "#downloadXLSX", function() {
		let totalDist:number = parseInt(meter_to_mi(window.tripPlannerCurrentTrip.directions.routes[0].summary.distance).toFixed(0));
		download_trip_xlsx(getTrip_cachedForm(window.tripPlannerCurrentTrip),totalDist).catch(e => {
			console.error(e);
		});
	});
};